// src/contexts/CartContext.js
import React, { createContext } from 'react';
import useLocalStorage from '../hooks/useLocalStorage';

export const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useLocalStorage('ofoodi-cart', []);
  return (
    <CartContext.Provider value={{ cart, setCart }}>
      {children}
    </CartContext.Provider>
  );
}
